import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Drives the "N new posts" banner. A live Turbo Stream appends a lightweight
// signal (author + post id) into #new-posts-signals for every new post; we
// count the ones from other users that are newer than what's shown, and reveal
// the banner. Clicking it fetches those posts and prepends them.
export default class extends Controller {
  static targets = ["signals", "banner", "count"]
  static values = { currentUser: Number, latest: Number }

  connect() {
    this.observer = new MutationObserver(() => this.recount())
    this.observer.observe(this.signalsTarget, { childList: true })
  }

  disconnect() {
    this.observer.disconnect()
  }

  fresh() {
    return [...this.signalsTarget.querySelectorAll("[data-new-post]")].filter(
      (s) =>
        Number(s.dataset.authorId) !== this.currentUserValue &&
        Number(s.dataset.postId) > this.latestValue
    )
  }

  recount() {
    const n = this.fresh().length
    this.countTarget.textContent = n
    this.bannerTarget.hidden = n === 0
  }

  async load(event) {
    event.preventDefault()
    const ids = this.fresh().map((s) => Number(s.dataset.postId))
    if (ids.length === 0) return

    const res = await fetch(`/posts?after=${this.latestValue}`, {
      headers: { Accept: "text/vnd.turbo-stream.html" },
    })
    Turbo.renderStreamMessage(await res.text())

    this.latestValue = Math.max(...ids)
    this.signalsTarget.innerHTML = ""
    this.recount()
  }
}
